// extracted by mini-css-extract-plugin
export default {"playlist":"Playlist_playlist__fn9EM","playlist__splide":"Playlist_playlist__splide__0JQzL","watch-next-heading":"Playlist_watch-next-heading__fFbR0"};